<template>
    <div class="form-wrapper">

        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="text"
            label="すきなものの名前 / 10文字まで(※必須)"
            :rules="commentRules"
            counter="10"
            single-line
          >
          </v-text-field>

          <v-text-field
            v-model="description"
            label="説明 / 100文字まで"
            counter="100"
            single-line
          >
          </v-text-field>

          <v-text-field
            v-model="name"
            label="投稿者名（必須） /10文字まで"
            :rules="commentRules"
            single-line
          >
          </v-text-field>

           <v-text-field
            v-model="twitter"
            label="ツイッターアカウント"
            single-line
          >
          </v-text-field>

          <v-btn
          :disabled="!valid"
          v-on:click="addComment"
          >
          投稿する
          </v-btn>

        </v-form>    

    </div>

</template>

<script>
 import {db} from '../plugins/firebase';

  export default {
    name: "postform",
    data: () => ({
      //form入力データ
      text:"",
      description:"",
      name:"",
      twitter:"",
      //バリデーション
      valid:true,
      commentRules: [
        v => !!v || 'コメントは必須項目です',
      ],
    //  required: value => !!value || "必ず入力してください", // 入力必須の制約
    //  limit_length10: value => value.length <= 10 || "10文字以内で入力してください", // 文字数の制約
    //  limit_length100: value => value.length <= 100 || "100文字以内で入力してください", // 文字数の制約
    }),
    
    methods:{
        //コメント追加
        addComment() {
            console.log(this.text);
            console.log(this.description);
            db.collection('emotions').add({
              text:this.text,
              description:this.description,
              name:this.name,
              twitter:this.twitter,
            })
            this.clear();
           
        },
        //fromの初期化
        clear(){
          this.$refs.form.reset()
        }
    }
  }

</script>